import { tryParseJSONObject } from '@fox/atoms/utils/string';
import { nanoid } from 'nanoid';
import { IQuestionAnswer } from '../../../../form-root';
import { DataTableCustomFieldHandling, QuestionBlockMetadata, QuestionBlockProps } from '../../contracts';

export interface IRenderDataTableQuestionProps {
	id: string;
	fieldProps: QuestionBlockProps;
}

/* We cannot import from @fox/fields 🙃 */
export const FIELD_STRING = 'string';
export const FIELD_NUMBER = 'number';
export const FIELD_CHECKBOX = 'check-box';
export const FIELD_TIME = 'time';
export const FIELD_SELECT = 'select';
export const FIELD_DATETIME = 'datetime';

export type DataTableAnswers = DataTableRowAnswer[];
export type DataTableRowAnswer = { rowId: string } & Record<string, string>;

export function defaultCustomFieldTableAnswer(question: any): IQuestionAnswer | undefined {
	const { type: questionType, name: questionName, metadataJson } = question;
	if (!questionType || !questionName) return undefined;
	if (questionType !== 'DataTable') return undefined;

	const props = tryParseJSONObject<QuestionBlockMetadata>(metadataJson, {});
	if (!props?.dataTableCustomFields) return undefined;

	const dataTableCustomFields: DataTableCustomFieldHandling[] = props.dataTableCustomFields ?? [];

	return {
		questionName,
		answer: {
			answerJson: JSON.stringify(buildDefaultCustomFieldDataTableAnswer(dataTableCustomFields))
		},
		type: questionType
	};
}

//TODO: Deal with actual multiple row mode later
export function buildDefaultCustomFieldDataTableAnswer(dataTableCustomFields: DataTableCustomFieldHandling[]): DataTableRowAnswer[] {
	//debugger;
	const res: DataTableRowAnswer = {
		rowId: nanoid()
	};
	for (const field of dataTableCustomFields) {
		if (field.type === FIELD_DATETIME && field.defaultValue == '@today') {
			res[field.fieldId] = new Date().toISOString();
			continue;
		}
		res[field.fieldId] = field.defaultValue || '';
	}
	return [res];
}

export interface DataTableCustomFieldComponentArgs {
	questionId: string;
	field: DataTableCustomFieldHandling;
	row: DataTableRowAnswer;
	handleChange: (value: string, rowId: string, fieldId: string) => void;
}

export const SUPPORTED_DATA_TABLE_CUSTOM_FIELD_TYPES: string[] = [
	FIELD_STRING,
	FIELD_NUMBER,
	FIELD_DATETIME,
	FIELD_TIME,
	FIELD_CHECKBOX,
	FIELD_SELECT
];

export type Option = {
	label: string;
	id: string;
};

export interface RenderSelectEditProps {
	allowMulti: boolean;
	allowClear: boolean;
	colourCoded: boolean;
	options: Option[];
	deletedOptions: { label: string; colour?: string; id?: string }[];
}

export interface RenderTextEditMetaProps {
	isQuickSearchable?: boolean;
	singleLine?: boolean;
	characterLimitLength?: number;
}
